import { render, staticRenderFns } from "./BulkOpsHeader.vue?vue&type=template&id=3b2dae22&"
import script from "./BulkOpsHeader.vue?vue&type=script&lang=js&"
export * from "./BulkOpsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports